import { gql } from '@common/hooks';

export type HistoryInfoFragmentType = {
  changes: {
    type: string | undefined;
    dataAfter: unknown | undefined;
    dataBefore: unknown | undefined;
    fieldName: string;
    valueAfter: string | undefined;
    valueBefore: string | undefined;
  }[];
  date: string;
  description: string | undefined;
  text: string;
  textHighlightedWords: string[];
};

// @TODO: rename it to HISTORY_INFO_FRAGMENT
export const HistoryInfoFragment = gql`
  fragment HistoryInfoFragment on History {
    text
    textHighlightedWords
    description
    changes {
      type
      dataAfter
      dataBefore
      fieldName
      valueBefore
      valueAfter
    }
    date
  }
`;
